export const hasContractNonScheduledShift = (
  showUnscheduledEmployees: boolean,
  shiftIds: number[] = []
) => {
  return !showUnscheduledEmployees && !shiftIds.length
}
